<template>
    <div id="quote-member-new">
      <div class="row mt-2">
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="text-left">First Name</label>
          <span class="required-asterisk">*</span>
          <input type="text" v-model="firstName" class="input-field" :class="{ 'form-invalid': $v.firstName.$error }"
                 placeholder="Enter First Name" />
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.firstName.required && $v.firstName.$error">
            The first name field is required
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="label-title text-left">Last Name</label>
          <span class="required-asterisk">*</span>
          <input type="text" v-model="lastName" class="input-field" :class="{ 'form-invalid': $v.lastName.$error }"
                 placeholder="Enter Last Name" />
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.lastName.required && $v.lastName.$error">
            The last name field is required
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="label-title mb-2">DOB</label>
          <span class="required-asterisk">*</span>
          <date-picker aria-describedby="input-feedback" placeholder="MM/DD/YYYY" @input="$v.dob.$touch();"
                       class="send-quote-date-picker" v-model="dob" :class="{ 'date-invalid': $v.dob.$error }"
                       value-type="format" format="MM/DD/YYYY">
          </date-picker>
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.dob.required && $v.dob.$error">
            The dob field is required
          </div>
          <div class="form-error ml-3 mt-2" v-if="$v.dob.required && $v.dob.$error">
            You must be 18 years to proceed
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="label-title">Zip</label>
          <span class="required-asterisk">*</span>
          <input type="number" :class="{ 'form-invalid': $v.zip.$error }" @input="$v.zip.$touch();" v-model="zip"
                 oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                 maxlength="5" class="input-field" placeholder="Enter Zip" />
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.zip.required && $v.zip.$error">
            The zip field is required
          </div>
          <div class="form-error text-left ml-3 mt-2" v-if="$v.zip.required && $v.zip.$error">
            Enter 5 digit zip code.
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="label-title">Tier</label>
          <span class="required-asterisk">*</span>
          <select v-model="tier" :class="{ 'form-invalid': $v.tier.$error }" class="send-custom-select  mt-1">
            <option value="" disabled>Choose Tier</option>
            <option v-for="(tier, index) in tierOptions" :value="tier.value" :key="index">{{ tier.text }}</option>
          </select>
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.tier.required && $v.tier.$error">
            The tier field is required
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="text-left">Salary <span class="optional-text">(Optional)</span></label>
          <input type="number" v-model="salary" class="input-field" placeholder="Enter Salary" />
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="label-title">Gender</label>
          <span class="required-asterisk">*</span>
          <select v-model="gender" :class="{ 'form-invalid': $v.gender.$error }" class="send-custom-select  mt-1">
            <option value="" disabled>Choose Gender</option>
            <option v-for="(gender, index) in genderOptions" :value="gender.value" :key="index">{{ gender.text }}
            </option>
          </select>
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.gender.required && $v.gender.$error">
            The gender field is required
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="label-title">Email</label>
          <span class="required-asterisk">*</span>
          <input type="text" v-model="email" @input="$v.email.$touch();" class="input-field"
                 :class="{ 'form-invalid': $v.email.$error }" placeholder="Enter Email" />
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.email.required && $v.email.$error">
            The email field is required
          </div>
          <div class="form-error  text-left ml-3 mt-2" v-if="$v.email.required && $v.email.$invalid">
            Enter valid email address
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
          <label class="label-title">Enrollment Platform</label>
          <span class="required-asterisk">*</span>
          <select v-model="platform" :class="{ 'form-invalid': $v.platform.$error }"
                  class="send-custom-select  mt-1" disabled>
            <option :value="null" disabled>Choose Enrollment Platform</option>
            <option v-for="(platform, index) in [platform]" :value="platform" :key="index">{{ platform.text }}
            </option>
          </select>
          <div class="form-error text-left ml-3 mt-2" v-if="!$v.platform.required && $v.platform.$error">
            The platform field is required
          </div>
        </div>

        <!--dependent information-->
        <div v-if="tier.length && tier!=='IO'">
          <div class="row">
            <div class="col-xxl-4 col-lg-4 col-md-6 mb-3" v-if="tier === 'IS' || tier==='IF'" >
              <label class="label-title mb-2">DOB (Spouse / Partner)</label>
              <span class="required-asterisk">*</span>
              <date-picker aria-describedby="input-feedback" placeholder="MM/DD/YYYY" @input="$v.spouseDob.$touch();"
                           class="send-quote-date-picker" v-model="spouseDob" :class="{ 'date-invalid': $v.spouseDob.$error }"
                           value-type="format" format="MM/DD/YYYY">
              </date-picker>
              <div class="form-error text-left ml-3 mt-2" v-if="!$v.spouseDob.required && $v.spouseDob.$error">
                The spouse dob field is required
              </div>
              <div class="form-error ml-3 mt-2" v-if="$v.spouseDob.required && $v.spouseDob.$error">
                Spouse age must be at least 18 years
              </div>
            </div>
            <div class="col-xxl-4 col-lg-4 col-md-6 mb-3" v-if="tier === 'IC' || tier === 'IF'">
              <label class="text-left">Children</label>
              <span class="required-asterisk">*</span>
              <input type="number" v-model="childNumber" class="input-field" placeholder="Enter Number Of Children" @input="$v.childNumber.$touch();"
                     :class="{ 'form-invalid': $v.childNumber.$error }"/>
              <div class="form-error text-left ml-3 mt-2" v-if="!$v.childNumber.required && $v.childNumber.$error">
                The children field is required
              </div>
              <div class="form-error ml-3 mt-2" v-else-if="!$v.childNumber.greaterThanZero">
                The number of children must be 0 (min) and 8 (max)
              </div>
              <div class="form-error ml-3 mt-2" v-else-if="$v.childNumber.required && !$v.childNumber.isWholeNumber">
                The number can't be negative or decimal
              </div>
            </div>
          </div>
        </div>


        <!--Go to next step button-->
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 d-flex justify-content-end">
          <button type="submit" @click="goToNextStep" class="new-quote-btn mt-0">Next</button>
        </div>
        <!--      </div>-->
      </div>
    </div>
</template>

<script>
import {email, required} from "vuelidate/lib/validators";
import {checkValidZip, isOver18} from "../../../../utils/validator";
import Api from "@/resource/Api";

export default {
    name: "GroupMemberDetails",
    props:{
     currentGroupPlatform :{
        type: [String, Number],
        required: true,
     },
          groupCensusId: {
            type: [String, Number],
            required: true,
        },
    },
    validations: {
    firstName: {
      required
    },
    lastName: {
      required
    },
    dob: {
      required,
      isOver18
    },
    zip: {
      required,
      checkValidZip
    },
    tier: {
      required
    },
    gender: {
      required
    },
    email: {
      required,
      email
    },
    platform: {
      required
    },
    spouseDob: {
      required,
      isOver18,
    },
    childNumber: {
      required,
      greaterThanZero: (value) => value >= 0 && value <=8,
      isWholeNumber: (value) => Number.isInteger(Number(value)),
    },
  },

    data() {
        return {
            firstName: '',
            lastName: '',
            dob: '',
            zip: '',
            tier: '',
            salary: '',
            gender: '',
            email: '',
            platform: '',
            spouseDob: '',
            childNumber: '',

            tierOptions: [
                { value: 'IO', text: 'Member Only' },
                { value: 'IS', text: 'Member + Spouse' },
                { value: 'IC', text: 'Member + Children' },
                { value: 'IF', text: 'Family' }
            ],
            genderOptions: [
                { value: 'M', text: 'Male' },
                { value: 'F', text: 'Female' }
            ],
        }
    },

    methods: {
      goToNextStep() {
          this.$v.$touch();
            if (!this.isFormValid(this.$v)){
              return;
            }
            else{
              this.saveTempInfo().then((response)=>{
                if(response.status === 200){
                  this.getPlansAndCategories();
                  this.$store.commit('setCurrentGroupQuoteStep', 1);
                }
              })
            }
      },

      isFormValid(validationObject) {
        const defaultFields = ['firstName', 'lastName', 'dob', 'tier', 'zip', 'platform', 'email', 'gender'];
        const areDefaultFieldsValid = defaultFields.every(field => !validationObject[field]["$error"]);

        if (this.tier === "IO") {
          return areDefaultFieldsValid;
        }
        else if (this.tier === "IS") {
          return areDefaultFieldsValid
              && !validationObject["spouseDob"]["$error"];
        }
        else if (this.tier === "IC") {
          return areDefaultFieldsValid && !validationObject["childNumber"]["$error"];
        }
        else if (this.tier === "IF") {
          return areDefaultFieldsValid &&
              !validationObject["spouseDob"]["$error"] &&
              !validationObject["childNumber"]["$error"];
        }
        return false;
      },

      getURLbyTier(){
        let url = 'v2/quote/get-plan-category?';
        const memberEnrollmentID= this.$store.getters.memberEnrollmentID;
        const formattedSpouseDOB = this.spouseDob ? this.convertDateFormat(this.spouseDob) : '';

        if(this.tier === "IC"){
          return  url + `enrollment_id=${memberEnrollmentID}&no_of_children=${this.childNumber}`
        }

        else if(this.tier === "IS"){
          return url + `enrollment_id=${memberEnrollmentID}}&dep_dob=${formattedSpouseDOB}`
        }

        else if(this.tier === 'IF'){
          return url + `enrollment_id=${memberEnrollmentID}&dep_dob=${formattedSpouseDOB}&no_of_children=${this.childNumber}`;
        }

        else return url + `enrollment_id=${memberEnrollmentID}`;
      },

      convertDateFormat(dateStr) {
        const [month, day, year] = dateStr.split('/');
        return `${year}/${month}/${day}`;
      },

      convertSpouseDobFormat(dateStr){
        const [year, month, day] = dateStr.split('/');
        return `${month}/${day}/${year}`;
      },

      saveTempInfo(){
            const payload = {
            group_census_id:this.groupCensusId,
            member_fname: this.firstName,
            member_lname: this.lastName,
            dob: this.dob,
            zip_code: this.zip,
            tier: this.tier,
            salary: this.salary,
            gender: this.gender,
            email: this.email,
            portal: this.platform.text,
          }

          const url = `v2/quote/save-memberenrollment-temp`
          const loader = this.$loading.show();

          return Api.post(url, payload).then((response) => {
            this.$notify("Member information saved successfully");

            const memberDetails = payload;
            memberDetails["dep_dob"] = this.spouseDob ? this.convertDateFormat(this.spouseDob) : '';
            memberDetails["no_of_children"] = this.childNumber ? this.childNumber : '';

            this.$store.commit('setGroupMemberDetails', memberDetails)

            const memberEnrollmentID = response.data.message;
            this.$store.commit('setMemberEnrollmentID', memberEnrollmentID);
            return response;
          }).catch(err=>{
            this.$notify(err.response.data.message || "Unable to save data", "error");
          }).finally(()=>{
            loader.hide();
          })

      },

      getPlansAndCategories() {
        const url = this.getURLbyTier();
        const loader = this.$loading.show();
        Api.get(url).then((response) => {
          const planData = response.data.data;
          //update store
          this.$store.commit('setPlanData', planData);
          this.$store.commit('setPlanCategories');
          this.$store.commit('setCurrentGroupQuoteStep', 1);
        }).catch((error) => {
          this.$notify(error.response.data.message, "error");
        }).finally(() => {
          loader.hide();
        })
      },

      setFormDetails() {
        const memberDetails = this.$store.getters.groupMemberDetails;

        if (Object.keys(memberDetails).length > 0) {
          this.firstName = memberDetails.member_fname;
          this.lastName = memberDetails.member_lname;
          this.dob = memberDetails.dob;
          this.tier = this.tierOptions.find(item => item.text === memberDetails.tier || item.value === memberDetails.tier)["value"];
          this.gender = this.genderOptions.find(gender => gender.text === memberDetails.gender || gender.value === memberDetails.gender)["value"];
          this.zip = memberDetails.zip_code;
          this.salary = memberDetails.salary;
          this.email = memberDetails.email;
          this.spouseDob = memberDetails.dep_dob ? this.convertSpouseDobFormat(memberDetails.dep_dob) : '';
          this.childNumber = memberDetails.no_of_children ? memberDetails.no_of_children : null;
        }
      },


      setPlatformValue() {
            //setting current enrollment plaform option as initial selected value
            this.platform = {
                text: this.currentGroupPlatform ? this.currentGroupPlatform : "",
                value: this.currentGroupPlatform.value || this.currentGroupPlatform || ""
            }
      },
    },

    created(){
     this.setPlatformValue();
     this.setFormDetails();
    }
}
</script>

<style scoped>
.new-quote-btn{
  max-width: fit-content;
}

</style>